// @ts-nocheck
import {
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifErrorMessage,
  MotifProgressLoader,
  MotifButton,
  MotifIcon,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifCheckbox,
} from "@ey-xd/motif-react";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import React, { useEffect, useRef, useState } from "react";
import {
  AMOUNT_PER_PROOF_OF_CLAIM_FIELD,
  ASSIGNEE,
  ASSIGNEE_FIELD,
  RESOLVE_STATUS_FIELD,
  UNIT,
  UNIT_ORIGINAL_AMOUNT,
  ORIGINAL_AMOUNT_PER_PROOF_OF_CLAIM_FIELD,
} from "./Constants";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { ClaimDetailsType } from "./type";
import ControlSelect from "./ControlSelect";
import "./ClaimDetailsContent.scss";
import Button from "@/components/Form/Button/Button";
import { useGetClaimItemDetailsQuery } from "@/services/claimDetail/claimDetailReducer";
import { SearchCreditor } from "./searchCreditor";
import ClaimItemIdentification from "./components/ClaimItemIdentification";
import "./ClaimDetailsContent.scss";
import ControlInputBox from "@/components/Form/InputBox/ControlInputBox";
import { CommentHistory } from "@/features/claimsummary/summary/component/commentHistory";
import {
  checkAmountDecimalError,
  formatAmountWithCommas,
  handleAttributeData,
  havingEditPermission,
} from "@/utility/common";
import { getCurrencyOptions } from "./ClaimDetailsHelper";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import {
  useGetCreditorQuickSearchApiDataQuery,
  useUpdateClaimItemMutation,
} from "@/services/claimSummary/caseSummaryReducer";
import { ENTITYTYPE } from "@/appConstants";
import CustomAttribute from "@/components/CustomAttribute/CustomAtrribute";
import { AttributeType } from "../../Configuration/Attributes/type";
import ControlInputBoxNumber from "@/components/Form/InputBox/ControlInputBoxNumber";
import { isNumeric, isNumericOrNull } from "@/utility/validation";
import { amountUnitDecimalPlace } from "@/utility/common";
import { useCase } from "@/features/case/use-case";
import { postClaimItemData } from "./ClaimDetailsHelper";
import { useDispatch } from "react-redux";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import {
  CANCEL_BUTTON_VARIANT,
  CONFIRM_BUTTON_VARIANT,
  getCommonEditImg,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { useSelector } from "react-redux";

export default function ClaimDetailsContent({
  claimItemId,
  claimId,
  getClaimItemstatus,
  claimStagePosition,
}: {
  claimItemId: string;
  claimId: string;
  getClaimItemstatus: any;
  claimStagePosition: any;
}) {
  const [isIdentificationTabOpen, setIsIdentificationTabOpen] =
    React.useState(true);
  const caseData = useCase();
  const caseId = caseData.caseId;
  const [isAmountTabOpen, setIsAmountTabOpen] = React.useState(true);
  const [isCommentTabOpen, setIsCommentTabOpen] = React.useState(true);
  const [claimStagePopUp, setClaimStagePopUp] = useState(false);
  const [disableStagePopUp, setDisableStagePopUp] = useState(false);
  const [isAttributesTabOpen, setIsAttributesTabOpen] = React.useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [attributesValue, setAttributesValue] = useState([]);
  const [intialAttributesValue, setIntiaslAttributesValue] = useState([]);
  const permissions = useSelector((state: any) => state.permissions);
  const { ClaimItem, AttributeValue } = permissions;
  const [isAttributesError, setIsAttributesError] = useState(false);
  const [isDecimalError, setIsDecimalError] = useState(false);
  const [isOriginalDecimalError, setIsOriginalDecimalError] = useState(false);
  const [editOriginalAmount, setEditOriginalAmount] = useState(false);
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permission = useSelector((state: any) => state.permissions);
  const { OriginalAmountUpdate } = permission;
  const [showAttributesWithValue, setShowAttributesWithValue] =
    useState<any>(false);
  const isCaseManager =
    OriginalAmountUpdate && OriginalAmountUpdate.includes("Execute");
  const editView = true;
  const [updateClaimItem] = useUpdateClaimItemMutation();
  const {
    data: claimItem,
    error,
    isLoading,
  } = useGetClaimItemDetailsQuery({ claimItemId: claimItemId, caseId: caseId });
  const currencyData = caseData?.caseUnits;
  const {
    data: assigneeList,
    error: assigneeError,
    isLoadingAssignee,
  }: any = useGetCreditorQuickSearchApiDataQuery({
    caseId: caseId,
  });
  let pageStatus = !havingEditPermission(ClaimItem);
  let attributeDisable = !havingEditPermission(AttributeValue);
  const currencyOptions =
    currencyData && getCurrencyOptions(currencyData, caseData);
  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    watch,
    formState: { errors, isDirty },
  } = useForm<ClaimDetailsType>({
    defaultValues: {
      amountPerProofOfClaim: claimItem?.currentAmount,
      assignee: claimItem?.assigneeId,
    },
  });
  const dispatch = useDispatch();
  const receivedUnit = currencyData?.find(
    (item: any) => item.id === claimItem?.currentAmountUnitId
  );
  const originalAmountDecimalPlace = currencyData?.find(
    (item: any) => item.name === claimItem?.originalAmountUnit
  );
  useEffect(() => {
    dispatch(
      setDiscardEditMode({
        editMode:
          isDirty ||
          !(
            JSON.stringify(intialAttributesValue) ===
            JSON.stringify(attributesValue)
          ),
      })
    );
    return () => {
      dispatch(setDiscardEditMode({ editMode: false }));
    };
  }, [dispatch, isDirty, attributesValue, intialAttributesValue]);
  const [decimalLimit, setDecimalLimit] = useState(
    caseData?.defaultUnitDecimal
  );
  useEffect(() => {
    if (claimItem) {
      setAttributesValue(claimItem.customAttributes);
      setIntiaslAttributesValue(claimItem.customAttributes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimItem, setValue]);
  useEffect(() => {
    setValue(
      AMOUNT_PER_PROOF_OF_CLAIM_FIELD,
      amountUnitDecimalPlace(
        claimItem?.currentAmount,
        receivedUnit?.decimalPlace || decimalLimit
      )
    );
    setValue(
      ORIGINAL_AMOUNT_PER_PROOF_OF_CLAIM_FIELD,
      claimItem?.originalAmount !== null &&
        claimItem?.originalAmount !== undefined
        ? amountUnitDecimalPlace(
            claimItem?.originalAmount,
            originalAmountDecimalPlace?.decimalPlace || decimalLimit
          )
        : ""
    );
    if (originalAmountDecimalPlace?.decimalPlace) {
      setDecimalLimit(receivedUnit?.decimalPlace);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimItem, receivedUnit, originalAmountDecimalPlace]);

  // useEffect(() => {
  //   if (caseData !== undefined) {
  //     setDecimalLimit(caseData?.defaultUnit?.decimalPlace);
  //   }
  // }, [caseData]);
  useEffect(() => {
    if (claimItem) {
      setValue(ASSIGNEE_FIELD, claimItem?.assigneeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimItem]);

  const [currenctUnit, amountPerProofOfClaim, originalUnit, originalAmount] =
    watch([
      "Unit",
      "amountPerProofOfClaim",
      "UnitOriginalAmount",
      "originalAmountPerProofOfClaim",
    ]);
  function handleDecimalLimit() {
    let decimalValue = 2;
    currencyData?.find((item: any) => {
      if (item.id === currenctUnit) {
        decimalValue = item.decimalPlace;
        return true;
      }
      return false;
    });
    return decimalValue;
  }

  function handleOriginalAmountDecimalLimit() {
    let decimalValue = 2;
    currencyData?.find((item: any) => {
      if (item.id === originalUnit) {
        decimalValue = item.decimalPlace;
        return true;
      }
      return false;
    });
    return decimalValue;
  }
  useEffect(() => {
    const currenctUnit = watch("Unit");
    //@ts-ignore
    currencyData &&
      currencyData.forEach((item) => {
        if (item.id === currenctUnit) {
          setDecimalLimit(item.decimalPlace);
          const currentAmountLatest = watch("amountPerProofOfClaim");
          if (
            currentAmountLatest &&
            checkAmountDecimalError(currentAmountLatest, item.decimalPlace)
          ) {
            setIsDecimalError(true);
            timeOutValue.current = setTimeout(() => {
              setIsDecimalError(false);
            }, 5000);
          } else {
            setIsDecimalError(false);
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currenctUnit, amountPerProofOfClaim]);
  let timeOutValue = useRef<any>(null);
  useEffect(() => {
    const currenctUnit = watch("UnitOriginalAmount");
    //@ts-ignore
    currencyData &&
      currencyData.forEach((item) => {
        if (item.id === currenctUnit) {
          const currentAmountLatest = watch("originalAmountPerProofOfClaim");
          if (
            currentAmountLatest &&
            checkAmountDecimalError(currentAmountLatest, item.decimalPlace)
          ) {
            setIsOriginalDecimalError(true);
            if (timeOutValue?.current) {
              clearTimeout(timeOutValue?.current);
            }
            timeOutValue.current = setTimeout(() => {
              setIsOriginalDecimalError(false);
            }, 5000);
          } else {
            setIsOriginalDecimalError(false);
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalUnit, originalAmount]);

  const selectedAssignee =
    assigneeList &&
    assigneeList?.find(
      (item: any) => item?.creditorId === claimItem?.assigneeId
    );

  const onChangeAmount = (value: string) => {
    if (value && checkAmountDecimalError(value, decimalLimit)) {
      setIsDecimalError(true);
      if (timeOutValue?.current) {
        clearTimeout(timeOutValue?.current);
      }
      timeOutValue.current = setTimeout(() => {
        setIsDecimalError(false);
      }, 5000);
    } else {
      setIsDecimalError(false);
    }
    if (claimStagePosition === 1) {
      setClaimStagePopUp(true);
    }
    if (disableStagePopUp === true) {
      setClaimStagePopUp(false);
    }
    return true;
  };

  const onChangeOriginalAmount = (value: string) => {
    return true;
  };
  if (isLoading || isLoadingAssignee)
    return <MotifProgressLoader show variant="default" />;
  if (error || assigneeError)
    return (
      <MotifErrorMessage>
        {t("global.globalNotifications.unExpectedError")}
      </MotifErrorMessage>
    );

  const defaultUnit = currencyData?.find((item: any) => item.isDefaultCurrency);

  const receivedOriginalUnit = currencyData?.find(
    (item: any) => item.name === claimItem?.originalAmountUnit
  );

  const decimalPlaceOfUnit = (name) => {
    const currentUnit = currencyData?.find((item: any) => item.name === name);
    return currentUnit?.decimalPlace;
  };

  const handleChange = (name: string, value: string) => {
    setValue(ASSIGNEE_FIELD, value);
  };

  let missingRequiredFieldsList = () => {
    const errorFieldsList: string[] = [];

    var isError = false;
    const required = attributesValue?.filter((x: any) => {
      return x.isRequired;
    });

    required?.map((x: any) => {
      switch (x.value.attributeType) {
        case AttributeType.FreeText:
          isError = !x.value.textValue;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Number:
          isError = !x.value.numberValue && x.value.numberValue !== 0;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Boolean:
          isError = !x.value.booleanValue && x.value.booleanValue !== false;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Date:
          isError = !x.value.dateValue;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.SingleSelect:
          isError = !x.value.selectedValue;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.MutliSelect:
          isError =
            !x.value.selectedValues || x.value.selectedValues.length === 0;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Currency:
          isError = x.value.amount === 0 || x.value.amount ? false : true;
          return isError && errorFieldsList.push(x.name);
      }
      return true;
    });
    setErrorFields(errorFieldsList);
    return errorFieldsList;
  };

  const attributesError = () => {
    var isError = false;
    let numberNotInRangeLabels: any = [];

    const required = attributesValue.filter((x: any) => {
      if (x.value.attributeType === AttributeType.Number) {
        let metaData = JSON.parse(x.metadataJSON);
        if (
          !(
            Number(x.value.numberValue) >= Number(metaData.minimum) &&
            Number(x.value.numberValue) <= Number(metaData.maximum)
          ) &&
          x.value.numberValue !== "" &&
          x.value.numberValue !== null
        ) {
          numberNotInRangeLabels.push(x.name);
        }
      }
      return x.isRequired;
    });
    if (numberNotInRangeLabels.length > 0) {
      setShowMessage({
        ...showMessage,
        show: true,
        message: t("global.globalNotifications.numberOutOfRange", {
          attributeName: numberNotInRangeLabels?.join(","),
        }),
        type: "error",
      });
      return true;
    }
    required.find((x: any) => {
      switch (x.value.attributeType) {
        case AttributeType.FreeText:
          isError = !x.value.textValue;
          break;
        case AttributeType.Number:
          isError = !x.value.numberValue && x.value.numberValue !== 0;
          break;
        case AttributeType.Boolean:
          isError = !x.value.booleanValue && x.value.booleanValue !== false;
          break;
        case AttributeType.Date:
          isError = !x.value.dateValue;
          break;
        case AttributeType.SingleSelect:
          isError = !x.value.selectedValue;
          break;
        case AttributeType.MutliSelect:
          isError =
            !x.value.selectedValues || x.value.selectedValues.length === 0;
          break;
        case AttributeType.Currency:
          isError = !x.value.amount;
          break;
        // case AttributeType.Document:
        //   isError = !x.value.displayName;
        //   break;
        default:
          isError = false;
      }
      return isError;
    });

    return isError;
  };

  // const errorList = Object.keys(errors);
  // const errorsShow = errorList
  //   .join(", ")
  //   .replace(AMOUNT_PER_PROOF_OF_CLAIM_FIELD, "Current Amount");

  const onSubmit = async (data: ClaimDetailsType) => {
    if (missingRequiredFieldsList().length > 0) {
      setShowAttributesWithValue(false);
      return;
    }
    if (attributesError()) {
      setShowAttributesWithValue(false);
      setIsAttributesError(true);
    } else {
      setIsSaveLoading(true);
      setIsAttributesError(false);
      const attributes = handleAttributeData(attributesValue);
      // attributesValue.forEach((value: any) => {
      //   if (value.value.attributeType !== AttributeType.Document) {
      //     attributes.push(value.value);
      //   }
      // });

      try {
        const itemData = postClaimItemData({ ...data, attributes: attributes });
        itemData.claimItemId = claimItemId;
        if (isCaseManager) {
          itemData.originalAmount = data?.originalAmountPerProofOfClaim
            ? parseFloat(data?.originalAmountPerProofOfClaim)
            : null;
          itemData.originalAmountUnitId = data?.UnitOriginalAmount;
        }

        dispatch(setDiscardEditMode({ editMode: false }));

        const responseApi = await updateClaimItem(itemData).unwrap();

        if (responseApi) {
          setIsSaveLoading(false);
          setShowMessage({ ...showMessage, show: true, type: "success" });
          setEditOriginalAmount(false);
          navigate(`/case/${caseId}/claim/${claimId}`, {
            state: { showMessage: true, update: true, defaultActiveKey: 3 },
          });
        } else {
          setShowMessage({ ...showMessage, show: true, type: "error" });
          setIsSaveLoading(false);
          dispatch(setDiscardEditMode({ editMode: true }));
        }
      } catch (error) {
        setShowMessage({ ...showMessage, show: true, type: "error" });
        setIsSaveLoading(false);
        dispatch(setDiscardEditMode({ editMode: true }));
      }
    }
  };
  let doc = document.getElementById("claimItemsAttributes");
  let attributesWithValue = doc?.childNodes.length > 0;
  if (!attributesWithValue && showAttributesWithValue) {
    doc.innerHTML = `<div  id="claimItemCustomValuesViewDummyId" class="motif-row">
  <div class="mar-l-30">${t(
    "global.globalNotifications.noAttributesFound"
  )}</div>
  </div>`;
  } else {
    let dummyDiv: any = document.getElementById(
      "claimItemCustomValuesViewDummyId"
    );
    if (dummyDiv && !showAttributesWithValue) {
      dummyDiv?.remove();
    }
  }

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisible(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisible(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
    navigate(-1);
  };

  const getOriginalAmountFieldPermission = () => {
    return pageStatus
      ? pageStatus
      : getClaimItemstatus
      ? getClaimItemstatus
      : claimItem?.isResolved;
  };

  return (
    <>
      {showMessage && showMessage.type === "error" && (
        <NotificationGrid
          show={showMessage.show}
          type={showMessage.type}
          message={showMessage?.message}
          onClose={() =>
            setShowMessage({
              show: false,
              type: "error",
            })
          }
        />
      )}
      <div className="claim-details-content">
        <form onSubmit={handleSubmit(onSubmit)}>
          <MotifAccordion
            onClose={() => setIsIdentificationTabOpen(false)}
            onOpen={() => setIsIdentificationTabOpen(true)}
            style={{
              flex: "1",
            }}
            open={isIdentificationTabOpen}
            useChevronIcon={true}
            alignIconRight={true}
          >
            <MotifAccordionTrigger>
              {t("pages.claims.claimItemEdit.subTitle1")}
            </MotifAccordionTrigger>
            <MotifAccordionContent>
              <div className="motif-row">
                <ClaimItemIdentification
                  errors={errors}
                  disabled={pageStatus}
                  control={control}
                  setValue={setValue}
                  getValues={getValues}
                  editView={editView}
                  selectedItem={{
                    categoryId: claimItem?.categoryId,
                    natureOfClaim: claimItem?.natureOfClaim.filter(
                      (value) => value !== ""
                    ),
                    getClaimItemstatus: getClaimItemstatus
                      ? getClaimItemstatus
                      : claimItem?.isResolved,
                  }}
                />
                <div className="motif-col-lg-4">
                  <div className="formFieldLabel">
                    <label aria-label={ASSIGNEE}>
                      {t("pages.claims.claimItemCommonLabels.assignee")}
                    </label>
                  </div>
                  <div className="form-field search-creditor">
                    <SearchCreditor
                      disabled={pageStatus}
                      handleChange={handleChange}
                      value={selectedAssignee?.creditorName}
                      getClaimItemstatus={
                        getClaimItemstatus
                          ? getClaimItemstatus
                          : claimItem?.isResolved
                      }
                    />
                    <span className="hide">
                      {/*@ts-ignore*/}
                      <ControlInputBox
                        name={ASSIGNEE_FIELD}
                        readonly={pageStatus}
                        control={control}
                        required={false}
                        isTextArea={false}
                        label={t("")}
                        showLabel={false}
                        setValue={setValue}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </MotifAccordionContent>
          </MotifAccordion>
          <MotifAccordion
            onClose={() => setIsAmountTabOpen(false)}
            onOpen={() => setIsAmountTabOpen(true)}
            style={{
              flex: "1",
            }}
            open={isAmountTabOpen}
            useChevronIcon={true}
            alignIconRight={true}
          >
            <MotifAccordionTrigger>
              {t("pages.claims.claimItemEdit.subTitle2")}
            </MotifAccordionTrigger>
            <MotifAccordionContent>
              {/* row 1 */}
              <div className="motif-row">
                <div className="motif-col-sm"></div>
                <div className="motif-col-sm">
                  <div className="title align-right">
                    {t("pages.claims.claimItemCommonLabels.originalAmount")}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="title align-right">
                    {t("pages.claims.claimItemCommonLabels.stageAmount")}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="title align-right">
                    {t(
                      "pages.claims.claimItemCommonLabels.latestCreditorPosition"
                    )}{" "}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="title align-right">
                    {t(
                      "pages.claims.claimItemCommonLabels.latestDebtorPosition"
                    )}{" "}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="title align-right">
                    {t("pages.claims.claimItemCommonLabels.resolvedAmount")}{" "}
                  </div>
                </div>
              </div>
              {/* row 2 */}
              <div className="motif-row pad-t-10">
                <div className="motif-col-sm">{defaultUnit?.name}</div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {claimItem.baseOriginalAmount === null ||
                    claimItem.baseOriginalAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.baseOriginalAmount,
                          defaultUnit?.decimalPlace
                        )} ${defaultUnit?.name}`}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {claimItem.baseCurrentAmount === null ||
                    claimItem.baseCurrentAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.baseCurrentAmount,
                          defaultUnit?.decimalPlace
                        )} ${defaultUnit?.name}`}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {claimItem?.isResolved ||
                    claimItem?.baseUnresolvedCreditorAmount === null ||
                    claimItem?.baseUnresolvedCreditorAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.baseUnresolvedCreditorAmount,
                          defaultUnit?.decimalPlace
                        )} ${defaultUnit?.name}`}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {claimItem?.isResolved ||
                    claimItem?.baseUnresolvedDebtorAmount === null ||
                    claimItem?.baseUnresolvedDebtorAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.baseUnresolvedDebtorAmount,
                          defaultUnit?.decimalPlace
                        )} ${defaultUnit?.name}`}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {!claimItem?.isResolved ||
                    claimItem.baseResolvedAmount === null ||
                    claimItem.baseResolvedAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.baseResolvedAmount,
                          defaultUnit?.decimalPlace
                        )} ${defaultUnit?.name}`}
                  </div>
                </div>
              </div>
              {/* row 3 */}
              <div className="motif-row pad-t-10">
                <div className="motif-col-sm">
                  {t("pages.claims.claimItemCommonLabels.Entered")}
                </div>
                {!editOriginalAmount ? (
                  <div className="motif-col-sm">
                    <div className="motif-body2-default-bold align-right display-flex align-items-center originalAmountContainer">
                      {claimItem.originalAmount === null ||
                      claimItem.originalAmount === undefined
                        ? "-"
                        : `${formatAmountWithCommas(
                            claimItem.originalAmount,
                            //receivedUnit?.decimalPlace
                            decimalPlaceOfUnit(claimItem?.originalAmountUnit)
                          )}
                       ${claimItem?.originalAmountUnit}`}
                      {isCaseManager && !getOriginalAmountFieldPermission() && (
                        <MotifButton
                          variant="ghost"
                          className="originalAmountImgContainer"
                          onClick={() => setEditOriginalAmount((prev) => !prev)}
                          role="button"
                          tabIndex={0}
                          aria-label="Edit Original Amount"
                        >
                          {getCommonEditImg("16")}
                        </MotifButton>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      position: "relative",
                      left: "30px",
                      bottom: "8px",
                    }}
                    className="motif-col-sm"
                  >
                    <div
                      style={{ width: "50px" }}
                      className="form-field motif-col-xs-4"
                    >
                      <ControlInputBoxNumber
                        name={ORIGINAL_AMOUNT_PER_PROOF_OF_CLAIM_FIELD}
                        control={control}
                        required={false}
                        isTextArea={false}
                        label={"pages.claims.claimItemCommonLabels.stageAmount"}
                        showLabel={false}
                        setValue={setValue}
                        isNumber={true}
                        digitAfterDecimal={handleOriginalAmountDecimalLimit()}
                        isAmount={true}
                        onChangeAmount={onChangeOriginalAmount}
                        validate={isNumericOrNull}
                        readonly={getOriginalAmountFieldPermission()}
                      />
                      <MotifErrorMessage
                        style={{ position: "relative", width: "220px" }}
                      >
                        {isOriginalDecimalError
                          ? t(
                              "pages.claims.claimItemCommonLabels.decimalErrorMessage"
                            )
                          : ""}
                        {errors?.originalAmountPerProofOfClaim?.type ===
                          "required" && !isOriginalDecimalError
                          ? t(
                              "pages.claims.claimItemCommonLabels.originalAmountRequired"
                            )
                          : errors?.originalAmountPerProofOfClaim?.type ===
                              "validate" && !isOriginalDecimalError
                          ? t(
                              "pages.claims.claimItemCommonLabels.originalAmountNotValid"
                            )
                          : ""}
                      </MotifErrorMessage>
                    </div>

                    <div
                      style={{ width: "50px" }}
                      className="form-field  motif-col-xs-4 OriginalAmountUnit"
                    >
                      <ControlSelect
                        name={UNIT_ORIGINAL_AMOUNT}
                        control={control}
                        required={true}
                        showLabel={false}
                        label={"pages.claims.claimItemCommonLabels.unit"}
                        options={currencyOptions}
                        setValue={setValue}
                        getValues={getValues}
                        value={receivedOriginalUnit?.id}
                        disabled={getOriginalAmountFieldPermission()}
                      />
                    </div>
                  </div>
                )}
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {claimItem.currentAmount === null ||
                    claimItem.currentAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.currentAmount,
                          //receivedUnit?.decimalPlace
                          decimalPlaceOfUnit(claimItem?.currentAmountUnit)
                        )}
                     ${claimItem?.currentAmountUnit}`}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {claimItem?.isResolved ||
                    claimItem?.unresolvedCreditorAmount === null ||
                    claimItem?.unresolvedCreditorAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.unresolvedCreditorAmount,
                          //receivedUnit?.decimalPlace
                          decimalPlaceOfUnit(
                            claimItem?.unresolvedCreditorAmountUnit
                          )
                        )}
                    ${claimItem?.unresolvedCreditorAmountUnit}`}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {claimItem?.isResolved ||
                    claimItem?.unresolvedDebtorAmount === null ||
                    claimItem?.unresolvedDebtorAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.unresolvedDebtorAmount,
                          //receivedUnit?.decimalPlace
                          decimalPlaceOfUnit(
                            claimItem?.unresolvedDebtorAmountUnit
                          )
                        )}
                     ${claimItem?.unresolvedDebtorAmountUnit}`}
                  </div>
                </div>
                <div className="motif-col-sm">
                  <div className="motif-body2-default-bold align-right">
                    {!claimItem?.isResolved ||
                    claimItem.resolvedAmount === null ||
                    claimItem.resolvedAmount === undefined
                      ? "-"
                      : `${formatAmountWithCommas(
                          claimItem.resolvedAmount,
                          //receivedUnit?.decimalPlace
                          decimalPlaceOfUnit(claimItem?.resolvedAmountUnit)
                        )}
                     ${claimItem?.resolvedAmountUnit}`}
                  </div>
                </div>
              </div>
              <div className={`motif-row pad-t-20`}>
                <div className="motif-col-lg-4">
                  <div className="form-field">
                    {/*@ts-ignore*/}
                    <ControlInputBoxNumber
                      name={AMOUNT_PER_PROOF_OF_CLAIM_FIELD}
                      control={control}
                      required={true}
                      isTextArea={false}
                      label={"pages.claims.claimItemCommonLabels.stageAmount"}
                      showLabel={true}
                      setValue={setValue}
                      isNumber={true}
                      digitAfterDecimal={handleDecimalLimit()}
                      isAmount={true}
                      onChangeAmount={onChangeAmount}
                      validate={isNumeric}
                      readonly={getOriginalAmountFieldPermission()}
                    />
                    <MotifErrorMessage>
                      {isDecimalError
                        ? t(
                            "pages.claims.claimItemCommonLabels.decimalErrorMessage"
                          )
                        : ""}
                      {errors?.amountPerProofOfClaim?.type === "required" &&
                      !isDecimalError
                        ? t(
                            "pages.claims.claimItemCommonLabels.stageAmountRequired"
                          )
                        : errors?.amountPerProofOfClaim?.type === "validate" &&
                          !isDecimalError
                        ? t(
                            "pages.claims.claimItemCommonLabels.stageAmountNotValid"
                          )
                        : ""}
                    </MotifErrorMessage>
                  </div>
                </div>
                <div className="motif-col-lg-2">
                  <div className="form-field">
                    <ControlSelect
                      name={UNIT}
                      control={control}
                      required={true}
                      showLabel={true}
                      label={"pages.claims.claimItemCommonLabels.unit"}
                      options={currencyOptions}
                      setValue={setValue}
                      getValues={getValues}
                      value={receivedUnit?.id}
                      disabled={getOriginalAmountFieldPermission()}
                    />
                  </div>
                </div>
                <div className="motif-col-lg-4">
                  <div className="form-field">
                    <ControlSelect
                      name={RESOLVE_STATUS_FIELD}
                      control={control}
                      required={true}
                      showLabel={true}
                      label={"pages.claims.claimItemCommonLabels.resolveStatus"}
                      options={[
                        {
                          label: t(
                            "pages.claims.claimItemCommonLabels.unresolved"
                          ),
                          value: "Unresolved",
                        },
                        {
                          label: t(
                            "pages.claims.claimItemCommonLabels.resolved"
                          ),
                          value: "Resolved",
                        },
                      ]}
                      disabled={pageStatus || getClaimItemstatus === true}
                      setValue={setValue}
                      getValues={getValues}
                      value={claimItem?.isResolved ? "Resolved" : "Unresolved"}
                    />
                  </div>
                </div>
              </div>
            </MotifAccordionContent>
          </MotifAccordion>

          <MotifAccordion
            onClose={() => setIsAttributesTabOpen(false)}
            onOpen={() => setIsAttributesTabOpen(true)}
            style={{
              flex: "1",
            }}
            open={isAttributesTabOpen}
            useChevronIcon={true}
            alignIconRight={true}
          >
            <MotifAccordionTrigger>
              {t("pages.claims.claimItemAttributes")}
            </MotifAccordionTrigger>
            <MotifAccordionContent>
              {claimItem.customAttributes &&
              claimItem.customAttributes?.length === 0 ? (
                <span>{t("pages.claims.noAttributesLabel")}</span>
              ) : (
                <>
                  <div className="motif-row ">
                    <MotifCheckbox
                      className="motif-col-lg-4"
                      checked={showAttributesWithValue}
                      onChange={(e: any) =>
                        setShowAttributesWithValue(e.target.checked)
                      }
                    >
                      {t("global.globalActions.showAttributesWithValues")}
                    </MotifCheckbox>
                  </div>

                  <div
                    id="claimItemsAttributes"
                    className="motif-row pad-t-20 mar-b-20"
                  >
                    {claimItem.customAttributes &&
                    attributesValue.length ===
                      claimItem.customAttributes.length ? (
                      claimItem.customAttributes.map(
                        (attribute: any, index: number) => {
                          return attribute.value.attributeType !==
                            AttributeType.Document ? (
                            <>
                              <CustomAttribute
                                showAttributesWithValue={
                                  showAttributesWithValue
                                }
                                disabled={attributeDisable}
                                customAttributeDetails={{
                                  ...attribute,
                                  metadataJSON: JSON.parse(
                                    attribute.metadataJSON
                                  ),
                                }}
                                customAttributeType={
                                  attribute.value.attributeType
                                }
                                attributeValue={attributesValue}
                                setAttributeValue={setAttributesValue}
                                index={index}
                                key={index}
                                errorFields={errorFields}
                                setErrorFields={setErrorFields}
                                variant="edit"
                              />
                            </>
                          ) : (
                            <></>
                          );
                        }
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              )}
            </MotifAccordionContent>
          </MotifAccordion>

          <MotifAccordion
            onClose={() => setIsCommentTabOpen(false)}
            onOpen={() => setIsCommentTabOpen(true)}
            style={{
              flex: "1",
            }}
            open={isCommentTabOpen}
            useChevronIcon={true}
            alignIconRight={true}
          >
            <MotifAccordionTrigger>
              {t("pages.claims.claimItemEdit.subTitle3")}
            </MotifAccordionTrigger>
            <MotifAccordionContent>
              <div className="pad-t-20">
                <CommentHistory
                  entityType={ENTITYTYPE.claimItem}
                  dataId={claimItemId}
                />
              </div>
            </MotifAccordionContent>
          </MotifAccordion>
          <div className="error-container">
            {/* <MotifErrorMessage>
              {errorList.length > 0
                ? t("pages.claims.claimItemCommonLabels.requiredMessage",{filedNames:errorsShow}
                )
                : ""}
            </MotifErrorMessage> */}
            <MotifErrorMessage>
              {isAttributesError
                ? t("pages.configuration.attributes.requiredFields")
                : ""}
            </MotifErrorMessage>
          </div>
          {pageStatus ? (
            <></>
          ) : (
            <div className="button-container sticky-footer">
              <Button
                label={t("global.globalActions.save")}
                type={isSaveLoading ? "loader" : "submit"}
                disabled={isSaveLoading}
                variant={SAVE_BUTTON_VARIANT}
              />
              <Button
                type="button"
                label={t("global.globalActions.cancel")}
                variant={CANCEL_BUTTON_VARIANT}
                className="cancelBtn"
                onClickHandler={(e) => {
                  if (
                    isDirty ||
                    !(
                      JSON.stringify(intialAttributesValue) ===
                      JSON.stringify(attributesValue)
                    )
                  ) {
                    setIsVisible(true);
                    dispatch(setDiscardEditMode({ editMode: false }));
                  } else {
                    cancelBtnApproveHandler(e);
                  }

                  setShowMessage({
                    ...showMessage,
                    show: false,
                    type: "error",
                  });
                }}
              />
            </div>
          )}
        </form>
        <ConfirmationModal
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          cancelBtnApproveHandler={cancelBtnApproveHandler}
          cancelBtnRejectHandler={cancelBtnRejectHandler}
        />
        <MotifModal
          onClose={() => setClaimStagePopUp(false)}
          show={claimStagePopUp}
          focusTrapOptions={{
            tabbableOptions: {
              displayCheck: "none",
            },
          }}
        >
          <div className="confirmationModalWrapper creditor_disabling_model">
            <MotifModalHeader
              headerIcon={
                <>
                  <span
                    style={{
                      backgroundColor: "rgb(252, 245, 243)",
                      borderRadius: "50px",
                      padding: "5px 8px 2px 8px",
                    }}
                  >
                    <MotifIcon
                      iconFunction={IconoirWarningTriangle}
                      strokeWidth="1"
                      size="15"
                      stroke="red"
                    />{" "}
                  </span>
                  <span
                    style={{
                      fontSize: 16,
                      display: "block",
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    {t("global.globalNotifications.warning")}
                  </span>
                </>
              }
            ></MotifModalHeader>

            <MotifModalBody style={{ paddingTop: "0px" }}>
              <span style={{ fontWeight: "300" }}>
                {t("pages.claims.claimItemEdit.ammountUpdateWarningMessage")}
              </span>
            </MotifModalBody>
            <MotifModalFooter>
              <MotifButton
                className=""
                onClick={() => {
                  setClaimStagePopUp(false);
                  setDisableStagePopUp(true);
                }}
                size="small"
                type="button"
                variant={CONFIRM_BUTTON_VARIANT}
              >
                {t("global.globalActions.confirm")}
              </MotifButton>
            </MotifModalFooter>
          </div>
        </MotifModal>
      </div>
    </>
  );
}
